import { AnimatePresence, motion } from 'framer-motion';
import React, { FC } from 'react';

import Bundle from '@/components/Layout/Header/Search/Suggestions/Bundle';
import HorizontalScroll from '@/components/Layout/Header/Search/Suggestions/HorizontalScroll';

import { Book } from '@/utils/interfaces/Library/Books';

interface Props {
  bundles?: Book[];
  onClickBook?: () => void;
}

const BundleCarousel: FC<Props> = ({ bundles, onClickBook }) => {
  return (
    <HorizontalScroll scrollAmount={250} className='sm:gap-3 gap-2'>
      <AnimatePresence mode='popLayout'>
        {bundles?.map((bundle, index) => (
          <motion.div
            key={bundle._id}
            layout
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25 }}
          >
            <Bundle onClickBook={onClickBook} bundle={bundle} key={index} />
          </motion.div>
        ))}
      </AnimatePresence>
    </HorizontalScroll>
  );
};

export default BundleCarousel;
